import type { Currency, CurrencyId } from "@/services/currencies/currenciesTypes";
import type { Price, PriceEmpty, PriceNumeric } from "./priceTypes";
import { EmptyPriceValue, isEmptyPrice, isNumericPrice } from "./priceValidators";
import { formatAmountWithCurrency } from "@/services/currencies/currenciesHelpers";

/* Comparators */
export const isEqualPrice = (priceA: Price, priceB: Price): boolean => {
  if (isNumericPrice(priceA) && isNumericPrice(priceB)) {
    return priceA.price === priceB.price && priceA.currencyId === priceB.currencyId;
  } else if (isEmptyPrice(priceA) && isEmptyPrice(priceB)) {
    return true;
  } else {
    return false;
  }
};

/* Factories */
export const createEmptyPrice = (): PriceEmpty => EmptyPriceValue;
export const createNumericPrice = (price: number, currencyId: CurrencyId): PriceNumeric => ({ price, currencyId });

/* Formatters */
export const formatPrice = (amount: number, currency: Currency): string => {
  return formatAmountWithCurrency(amount, currency);
};
